export const LINKEDIN_SHARE_URL = 'https://www.linkedin.com/feed/?shareActive=true';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet';
export const X_SHARE_URL = 'https://x.com/intent/post';
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php';

export enum SocialName {
  TWITTER = 'twitter',
  FACEBOOK = 'facebook',
  LINKEDIN = 'linkedin',
  X = 'x',
}

export const generateSocialMediaShareLink = (socialMedia: SocialName, baseLink: string) => {
  let shareUrl: URL;

  switch (socialMedia) {
    case SocialName.LINKEDIN: {
      shareUrl = new URL(LINKEDIN_SHARE_URL);
      shareUrl.searchParams.append('text', baseLink);
      break;
    }
    case SocialName.TWITTER: {
      shareUrl = new URL(TWITTER_SHARE_URL);
      shareUrl.searchParams.append('url', baseLink);
      break;
    }
    case SocialName.X: {
      shareUrl = new URL(X_SHARE_URL);
      shareUrl.searchParams.append('url', baseLink);
      break;
    }
    case SocialName.FACEBOOK: {
      shareUrl = new URL(FACEBOOK_SHARE_URL);
      shareUrl.searchParams.append('u', baseLink);
      break;
    }
    default: {
      throw new Error('Invalid social media');
    }
  }

  return shareUrl.toString();
};
